import { ChevronLeftMedium as IconComponent } from '@adobe/react-spectrum-ui/dist/ChevronLeftMedium.js';
import { UIIcon } from '@react-spectrum/icon';
import React from 'react';
export default function ChevronLeftMedium(props) {
  return /*#__PURE__*/React.createElement(UIIcon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}